import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; // ✅ ToastContainer import
import 'react-toastify/dist/ReactToastify.css';  // ✅ Toast styles import

import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import KineticLandingPage from './components/KineticLandingPage';
import AboutUs from './components/AboutUs';
import FileUploadPage from './components/FileUploadPage';
import RunOpenMKMPage from './components/RunOpenMKMPage';
import JobStatusPage from './components/JobStatusPage';
import UserManagement from './components/UserManagement';
import EditAccount from './components/EditAccount';
import ChangePassword from './components/ChangePassword';
import ProjectHistory from './components/ProjectHistory';
import ProjectDashboard from './components/ProjectDashboard';
import DataFittingPage from './components/DataFittingPage';
import DataFittingHistory from './components/DataFittingHistory';
import CompareFitsPage from './components/CompareFitsPage';
import RunHistoryPage from './components/RunHistoryPage';
import SystemsPage from './components/SystemsPage';
import HelpExamples from './components/HelpExamples';
// import { Contact } from 'lucide-react';
// import Contacts from './components/Contacts';
import Contact from '../src/components/Contact';
import UserGuide from '../src/components/UserGuide';
import TutorialsDashboard from '../src/components/Tutorials/Components/TutorialsDashboard';
import Tutorial1 from '../src/components/Tutorials/Components/Tutorial1';
import Tutorial2 from '../src/components/Tutorials/Components/Tutorial2';
import Tutorial3 from '../src/components/Tutorials/Components/Tutorial3';
import Tutorial4 from '../src/components/Tutorials/Components/Tutorial4';
import Tutorial5 from '../src/components/Tutorials/Components/Tutorial5';


function App() {
  return (
    <Router>
      <ToastContainer // ✅ Enables toasts globally
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/" element={<KineticLandingPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/upload" element={<FileUploadPage />} />
        <Route path="/run-openmkm" element={<RunOpenMKMPage />} />
        <Route path="/job-status" element={<JobStatusPage />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/edit-account" element={<EditAccount />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/project-history" element={<ProjectHistory />} />
        <Route path="/projects" element={<ProjectDashboard />} />
        <Route path="/data-fitting" element={<DataFittingPage />} />
        <Route path="/data-fitting-history" element={<DataFittingHistory />} />
        <Route path="/run-history" element={<RunHistoryPage />} />
        <Route path="/systems" element={<SystemsPage />} />
        <Route path="/compare-fits" element={<CompareFitsPage />} />
        <Route path="/userguide" element={<UserGuide />} />
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/examples" element={<HelpExamples />} />
        <Route path="/tutorialsdashboard" element={<TutorialsDashboard />} />
        <Route path="/Tutorial1" element={<Tutorial1 />} />
        <Route path="/Tutorial2" element={<Tutorial2 />} />
        <Route path="/Tutorial3" element={<Tutorial3 />} />
        <Route path="/Tutorial4" element={<Tutorial4 />} />
        <Route path="/Tutorial5" element={<Tutorial5 />} />
      </Routes>
    </Router>
  );
}

export default App;
